<template>
    <main class="auth-layout flex items-center justify-center">
        <router-view />
    </main>

    <LoadingOverlay />
    <NotifyOverlay />
</template>


<script setup>
    import LoadingOverlay from '@/components/common/overlays/LoadingOverlay.vue'
    import NotifyOverlay from '@/components/common/overlays/NotifyOverlay.vue'
</script>


<style scoped>
    .auth-layout {
        min-height: 100vh;
        background: url("@/assets/images/background.png") center center / cover no-repeat;
    }

    form {
        max-width: 400px;
        background-color: rgba(255, 255, 255, 0.6);
    }
</style>